module.exports = __webpack_public_path__ + "wirewax-offline/8201557/static/media/pxiByp8kv8JHgFVrLCz7Z11lFd2JQEl8qw.b9f2c13f.woff2";